// extracted by mini-css-extract-plugin
module.exports = {"main":"alert_main__IVK9B","body":"alert_body__JyLng","title":"alert_title__gHIFr","content":"alert_content__S6nyO"};